import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-上涨",
  "use": "icon-上涨-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-上涨\"><path d=\"M62.3 452.1h51.4v545.7H62.3z\" fill=\"#2171d1\" p-id=\"9030\" /><path d=\"M1023.8 76.7l0.1-0.3-179.6-49.9L830.6 76l95.4 26.5-389.5 220.2-107.6-190.3-25.3-44.7L0.1 315.9l25.3 44.7 358.8-202.9 132.9 235 44.7-25.3 389.4-220.2-26.4 95.4 49.5 13.7 49.8-179.5z\" fill=\"#fd8e01\" p-id=\"9031\" /><path d=\"M266.9 349.7h51.4v648h-51.4z\" fill=\"#2171d1\" p-id=\"9032\" /><path d=\"M471.5 520.3h51.4v477.4h-51.4z\" fill=\"#2171d1\" p-id=\"9033\" /><path d=\"M676.1 418h51.4v579.8h-51.4z\" fill=\"#2171d1\" p-id=\"9034\" /><path d=\"M880.1 486.2h51.4v511.5h-51.4z\" fill=\"#2171d1\" p-id=\"9035\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/上涨.svg
// module id = 4Y4U
// module chunks = 75